export interface Input extends Marko.Input<"select"> {
  inline?: boolean;
  label: string;
  readonly?: boolean; // not valid HTML, but helps with styling
  content: Marko.Body;
  tip?: string;
}

<const/{ inline, label, content, tip, ...others }=input>
<id/inputId>
<id/tipId>

<div.${inline && "inline"}>
  <label data-disabled=input.disabled for=inputId>${input.label}</label>
  <select#${inputId} ...others aria-describedby=tip ? tipId : undefined>
    <${content}/>
  </select>

  <if=tip>
    <sb-field-tip#${tipId}>${tip}</sb-field-tip>
  </if>
</div>

<style.scss>
  .inline {
    align-items: center;
    display: flex;
    gap: $space-md;
  }
</style>
